(function () {
  var lastY     = window.scrollY;
  var ticking   = false;
  var TOP_ZONE  = 80; // px — always expand at/near top
  var MIN_DELTA = 5;  // px — minimum scroll in one direction to act

  var settled = !window.location.hash || document.readyState === 'complete';
  function settle() { lastY = window.scrollY; settled = true; }
  if (!settled) {
    window.addEventListener('load', settle, { once: true });
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, settle, { once: true, passive: true });
    });
  }

  function update() {
    if (!settled) { lastY = window.scrollY; ticking = false; return; }

    var y     = window.scrollY;
    var delta = y - lastY;

    if (y <= TOP_ZONE) {
      document.body.classList.remove('is-nav-condensed');
    } else if (Math.abs(delta) >= MIN_DELTA) {
      if (delta > 0) {
        document.body.classList.add('is-nav-condensed');
      } else {
        document.body.classList.remove('is-nav-condensed');
      }
    }

    lastY   = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
